const inputCheckboxLabels = {
  checkout: {
    shipping: {
      lbl_checkbox_yes: 'Yes',
      lbl_checkbox_no: 'No',
    },
  },
};

export default inputCheckboxLabels;
